



































import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Layout';
import { DishCourseEnum } from '@/api/model';
import Hero from '@/components/Hero.vue';
import DishForm from '@/components/menu-engineering/DishForm.vue';
import Calculator from '@/logic/menu-engineering/Calculator';
import { LandingPageDish } from '@/logic/menu-engineering/LandingPageDish';
import LinkCorporate from '@/components/LinkCorporate.vue';
import SwitchLocale from '@/components/SwitchLocale.vue';

@Component({
  components: { Hero, Layout, DishForm, LinkCorporate, SwitchLocale },
})
export default class MenuEngineeringWelcome extends Vue {
  saving = false;

  dish: LandingPageDish = {
    restaurantType: '',
    course: DishCourseEnum.Breakfast,
    name: '',
    popularity: 0,
    costPrice: 0,
    chefTime: 0,
    staffTime: 0,
    price: 0,
    companyStaffSize: 0,
    companyStaffSeatCount: 0,
  };

  // Calculate the dish value and show the corresponding result page
  showResult() {
    const results = Calculator.calculate([this.dish]);
    const { score } = results[0];
    window.scrollTo(0, 0);
    this.$router.push(`/menu-engineering/result/${score?.toLowerCase()}`);
  }
}
